import { notification, Button } from "antd";
import error1 from "../assets/error.svg";
import successful from "../assets/successful.svg";
import info from "../assets/information.svg";
import alert from "../assets/alert.svg";
import moment from "moment-timezone";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
export const API_RETRY_LIMIT = 1;
// used for converting string words in cspitalized form
export const capitalizeWords = (str) => {
  return str
    ?.toLowerCase()
    ?.split(" ")
    ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
    ?.join(" ");
};
//function to get cookie
export const getCookie = (cname) => {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
export const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};
export const errorCode = [
  { key: -1, value: "Internal server error", msg: "unknown error" },
  { key: 6, value: "session expired! Please reload page" },
  {
    key: 1,
    value: "Split attribute name and Graph attribute names must be different",
  },
  { key: 2, value: "No data found for selected filter combinations" },
  {
    key: 3,
    value: "Something went wrong!",
    msg: "incomplete data from frontend",
  },
  {
    key: 4,
    value: "Internal server error",
  },
  { key: 5, value: "No data available for selected attributes" },
  {
    key: 7,
    value: "Internal server error. Please contact AWA team.",
    msg: "no database source available issue",
  },
  {
    key: 11,
    value:
      "Requested workspace does not exist! Redirecting you to reports page...",
    msg: "Report id does not exist",
  },
  {
    key: 13,
    value: "Cannot filter on multiple channels for page widgets",
    msg: "Cannot filter on multiple channels for page widgets",
  },
  {
    key: 9,
    value: "Your session has expired!",
    msg: "You are not logged in",
  },
  {
    key: 100,
    value: "You have exceeded the mention limit! Please contact AWA team.",
    msg: "Mention limit surpassed",
  },
  {
    key: 101,
    value:
      "You have exceeded the active workspace limit! Please contact AWA team.",
    msg: "active ws limit surpassed",
  },

  {
    key: 102,
    value: "Try again after a minute.",
    msg: "Keep one minute gap between report creation",
  },
  {
    key: 103,
    value: "Workspace creation timeout! Please try again.",
    msg: "Workspace creation timeout, retry from estimate",
  },

  {
    key: 104,
    value: "Another workspace creation in progress. Please wait!",
    msg: "Another workspace is in creation, wait for completion",
  },
];

// showing notification
export const callNotification = (message, value) => {
  return notification?.open({
    className: "notification_body",
    key: 1,
    placement: "bottomLeft",
    icon: (
      <img
        src={
          value === "error"
            ? error1
            : value === "info"
            ? info
            : value === "alert"
            ? alert
            : successful
        }
        alt={
          value === "error"
            ? "error"
            : value === "info"
            ? "info"
            : value === "alert"
            ? "alert"
            : "successful"
        }
      />
    ),
    btn: (
      <Button
        type="primary"
        size="small"
        className="notification_btn"
        onClick={() => notification?.destroy(1)}
      >
        Dismiss
      </Button>
    ),
    message: (
      <span className="notification_message">
        {value === "error"
          ? message
            ? message
            : "Internal Server Error!"
          : message}
      </span>
    ),
  });
};
// for redirect to session expired
export const sessionExpired = (value) => {
  let timer = null;
  if (value) {
    timer = setTimeout(() => {
      window.location.href = "/sessionexpired";
    }, 1000);
  }
  return () => {
    clearTimeout(timer);
  };
};
// for creating deep copy of old value
export const deepCopy = (oldValue) => {
  if (!oldValue) {
    return oldValue;
  }
  let newValue;
  let strValue = JSON.stringify(oldValue);
  newValue = JSON.parse(strValue);
  return newValue;
};
// to get the default channel settings value to bind dynamically
export const getDefaultChannelSettingsValue = () => {
  return {
    is_selected: true,
    channel_setting: {
      mention: false,
      hashtag: true,
      story_promotion: false,
      hashtag_list: [],
      keywords: {
        and_: [],
        or_: [],
        not_: [],
      },
      media_type: {
        image: true,
        video: false,
        text: true,
      },
      sentiment: null,
      followers_count_greater_than: 1000,
      followers_count_less_than: 5000,
    },
  };
};
export const isFloat = (n) => {
  return Number(n) === n && n % 1 !== 0;
};
export const kFormatter = (num, roundOfNotFlag, kpi) => {
  let isNegative = num < 0;
  if (Math.abs(num) >= 1000000000) {
    return (
      (isNegative ? "-" : "") +
      (Math.abs(num) / 1000000000).toFixed(1).replace(/\.0$/, "") +
      "G"
    );
  } else if (Math.abs(num) >= 1000000) {
    return (
      (isNegative ? "-" : "") +
      (Math.abs(num) / 1000000).toFixed(1).replace(/\.0$/, "") +
      "M"
    );
  } else if (Math.abs(num) >= 1000) {
    return (
      (isNegative ? "-" : "") +
      (Math.abs(num) / 1000).toFixed(1).replace(/\.0$/, "") +
      "k"
    );
  } else if (Math.abs(num)) {
    if (isFloat(num)) {
      if (kpi) {
        if (roundOfNotFlag) {
          return (isNegative ? "-" : "") + Math.abs(num).toFixed(2);
        } else {
          return (
            (isNegative ? "-" : "") +
            Math?.abs(num)?.toFixed(0)?.replace(/\.0$/, "")
          );
        }
      } else {
        return (
          (isNegative ? "-" : "") +
          Math?.abs(num)?.toFixed(1)?.replace(/\.0$/, "")
        );
      }
    } else {
      return num;
    }
  } else return num;
};

//function to get the customized date range
export const getCustomizedDate = (value, type, custom_relative, mode_type) => {
  let currentDate = new Date();
  let newDate = null;
  if (type === "Hours") {
    newDate = moment(currentDate).subtract(value, "h")._d;
  } else if (type === "Days") {
    newDate = moment(currentDate).subtract(value, "d")._d;
  } else if (type === "Weeks") {
    newDate = moment(currentDate).subtract(value, "week")._d;
  } else if (type === "Months") {
    newDate = moment(currentDate).subtract(value, "month")._d;
  } else if (type === "Years") {
    newDate = moment(currentDate).subtract(value, "year")._d;
  }
  let fromDate = custom_relative
    ? moment(newDate).add(1, "d").format("DD MMM  YYYY")
    : moment(newDate).format("DD MMM  YYYY");
  let fromTime = moment(newDate).format("HH:mm");
  let toDate = moment(currentDate).format("DD MMM YYYY");
  let toTime1 = moment(currentDate).format("HH:mm");
  let toTime = "23:59";

  let timeValue = {
    startTime: type === "Hours" ? fromTime : "00:00",
    endTime:
      type === "Hours" || mode_type === "schedule_date_time" ? toTime1 : toTime,
  };
  return { date: [fromDate, toDate], time: timeValue };
};

export const getTextWithWrapHtml = (text = "", cssClassForText = "") => {
  const regex = /([#@][a-z0-9_$&+,:;=?@|'<>.-^*()%!]*)/gi;
  const parts = text?.split(regex);
  return (
    <p className={cssClassForText}>
      {parts?.map((part, index) => {
        if (part?.match(regex)) {
          return (
            <span key={index} className="text-color-primary">
              {part}
            </span>
          );
        } else {
          return part;
        }
      })}
    </p>
  );
};
export const getValidVideoUrl = (videoUrlObj) => {
  // let exUrl =
  //   "https://video-yyz1-1.cdninstagram.com/v/t50.31694-16/192392977_165938305394794_5211220240356378107_n.mp4?_nc_cat=108&ccb=1-3&_nc_sid=8ae9d6&_nc_ohc=BcIH6ZRWKxUAX-fnjJS&_nc_ht=video-yyz1-1.cdninstagram.com&oh=57e6014d31701ac43930b38a85388898&oe=60B1EA3As";
  // let vObjEx = videoUrlObj ? deepCopy(videoUrlObj) : { ...videoUrlObj };
  // vObjEx.link = exUrl;
  // vObjEx.thumb_url = exUrl;
  let mediaObj = videoUrlObj ? deepCopy(videoUrlObj) : { ...videoUrlObj };

  // check is your url is valid
  if (mediaObj?.link && !isScontentLinkExpire(mediaObj?.link)) {
    return mediaObj?.link;
  } else if (
    mediaObj?.thumb_url &&
    !isScontentLinkExpire(mediaObj?.thumb_url)
  ) {
    return mediaObj?.thumb_url;
  } else if (
    typeof mediaObj === "string" &&
    mediaObj?.length &&
    !isScontentLinkExpire(mediaObj)
  ) {
    return mediaObj;
  }
  return false;
};
export const isScontentLinkExpire = (mediaUrl, channelType) => {
  let isExpired = false;
  try {
    if (
      mediaUrl &&
      mediaUrl?.indexOf("s3.amazonaws") == -1 &&
      mediaUrl?.indexOf("images.locobuzz.com") == -1
    ) {
      const tokens = mediaUrl?.split("&");
      const HexDecimalCode = tokens?.filter((x) => x?.includes("oe="));
      if (
        HexDecimalCode != null &&
        HexDecimalCode?.length > 0 &&
        HexDecimalCode?.[0]?.startsWith("oe=")
      ) {
        let DecimalEpoch = 0;
        if (HexDecimalCode?.length > 0) {
          const HexDecimalTime = HexDecimalCode?.[0]?.replace("oe=", "");
          DecimalEpoch = parseInt(HexDecimalTime, 16);
        }
        // DateTimeOffset.Now.ToUnixTimeSeconds()
        if (moment().unix() > DecimalEpoch && DecimalEpoch > 0) {
          isExpired = true;
        }
      }
    }
  } catch (exception) {
    return false;
  }

  return isExpired;
};
export const createCommaOrSpaceSeparatedTagsAndKeyword = (tags) => {
  let tagsArr = tags;
  let newTags = [];
  tagsArr?.forEach((item) => {
    if (item?.includes(",")) {
      const splitItemsBasedOnComma = item?.split(",");
      splitItemsBasedOnComma?.forEach((splitItem) => {
        let trimedSplitItem = splitItem?.trim();
        // check if space seprated word exits then split this also
        if (trimedSplitItem != "" && trimedSplitItem?.includes(" ")) {
          const splitItemsBasedOnSpace = trimedSplitItem?.split(" ");
          splitItemsBasedOnSpace?.forEach((sItem) => {
            if (sItem?.trim() != "") newTags.push(sItem?.trim());
          });
        } else if (trimedSplitItem != "") {
          newTags.push(trimedSplitItem);
        }
      });
    } else if (item?.includes(" ")) {
      const splitItemsBasedOnSpace = item?.split(" ");
      splitItemsBasedOnSpace?.forEach((splitItem) => {
        if (splitItem?.trim() != "") newTags.push(splitItem?.trim());
      });
    } else {
      if (item?.trim() != "") newTags.push(item?.trim());
    }
  });
  // remove empty space keyword or tags
  while (newTags?.length > 0 && newTags[newTags?.length - 1]?.trim() == "") {
    newTags?.pop();
  }

  return newTags;
};
